import * as THREE from "three"
import * as mesh3DOBJ from './mesh3D'
import { ParametricGeometries } from 'three/examples/jsm/geometries/ParametricGeometries.js';

export var eventInit = function ()
{
    var InputSources = document.getElementById('InputSources');
    InputSources.onchange = function(e){
        var index = InputSources.selectedIndex;
        var sourceType = InputSources[index].value;
        console.log( sourceType );
        if( sourceType === 'cone' )
        {
            mesh3DOBJ.UpdateSource( CreateCone() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'sphere' )
        {
            mesh3DOBJ.UpdateSource( CreateSphere() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'torus' )
        {
            mesh3DOBJ.UpdateSource( CreateTorus() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'box' )
        {
            mesh3DOBJ.UpdateSource( CreateBox() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'circle' )
        {
            mesh3DOBJ.UpdateSource( CreateCircle() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'cylinder' )
        {
            mesh3DOBJ.UpdateSource( CreateCylinder() );
            mesh3DOBJ.onMeshChanged();   
        }
        else if( sourceType === 'octahedron' )
        {
            mesh3DOBJ.UpdateSource( CreateOctahedron() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'klein bottle' )
        {
            mesh3DOBJ.UpdateSource( CreateKleinBottle() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'mobius' )
        {
            mesh3DOBJ.UpdateSource( CreateMobius() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'plane' )
        {
            mesh3DOBJ.UpdateSource( CreatePlane() );
            mesh3DOBJ.onMeshChanged();
        }
        else if( sourceType === 'heart' )
        {
            mesh3DOBJ.UpdateSource( CreateHeart() );
            mesh3DOBJ.onMeshChanged();
        }
    };
}

export var sourceInit = function()
{
    var InputSources = document.getElementById('InputSources');
    var index = InputSources.selectedIndex;
    var sourceType = InputSources[index].value;
    console.log( sourceType );
    if( sourceType === 'sphere' )
    {
        mesh3DOBJ.UpdateSource( CreateSphere() );
        mesh3DOBJ.onMeshChanged();
    }
}

function CreateCone()
{
    const geometry = new THREE.ConeGeometry( 5, 16, 32 );
    geometry.center();
    const material = new THREE.MeshLambertMaterial( {color: 0xffffff} );
    const cone = new THREE.Mesh( geometry, material );
    return cone;
}

function CreateSphere()
{
    const geometry = new THREE.SphereGeometry( 15, 32, 16 );
    geometry.center();
    const material = new THREE.MeshLambertMaterial( { color: 0xffffff } );
    const sphere = new THREE.Mesh( geometry, material );
    return sphere;
}

function CreateTorus()
{
    const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
    const material = new THREE.MeshLambertMaterial( { color: 0xffffff } );
    const torus = new THREE.Mesh( geometry, material );
    return torus;
}

function CreateBox()
{
    const geometry = new THREE.BoxGeometry( 10, 10, 10 );
    const material = new THREE.MeshLambertMaterial( {color: 0xffffff} );
    const cube = new THREE.Mesh( geometry, material );    
    return cube;
}

function CreateCircle()
{
    const geometry = new THREE.CircleGeometry( 5, 32 );
    const material = new THREE.MeshLambertMaterial( { color: 0xffffff } );
    const circle = new THREE.Mesh( geometry, material );
    return circle;
}

function CreateCylinder()
{
    const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
    const material = new THREE.MeshLambertMaterial( {color: 0xffffff} );
    const cylinder = new THREE.Mesh( geometry, material );
    return cylinder;
}

function CreateOctahedron()
{
    const geometry = new THREE.OctahedronGeometry( 10, 0 );
    const material = new THREE.MeshLambertMaterial( {color: 0xffffff} );
    const octahedron = new THREE.Mesh( geometry, material );
    return octahedron;
}

function CreateKleinBottle()
{
    const geometry = new THREE.ParametricGeometry( ParametricGeometries.klein, 25, 25 );
    const material = new THREE.MeshLambertMaterial( { color: 0xffffff } );
    const klein = new THREE.Mesh( geometry, material );
    return klein;
}

function CreateMobius()
{
    const geometry = new THREE.ParametricGeometry( ParametricGeometries.mobius3d, 25, 50 );
    const material = new THREE.MeshLambertMaterial( { color: 0xffffff } );
    const klein = new THREE.Mesh( geometry, material );
    return klein;
}

function CreatePlane()
{
    const geometry = new THREE.PlaneGeometry( 1, 1 );
    const material = new THREE.MeshLambertMaterial( {color: 0xffffff, side: THREE.DoubleSide} );
    const plane = new THREE.Mesh( geometry, material );
    return plane;
}

function CreateHeart()
{
    const x = 0, y = 0;
    const heartShape = new THREE.Shape();
    heartShape.moveTo( x + 5, y + 5 );
    heartShape.bezierCurveTo( x + 5, y + 5, x + 4, y, x, y );
    heartShape.bezierCurveTo( x - 6, y, x - 6, y + 7,x - 6, y + 7 );
    heartShape.bezierCurveTo( x - 6, y + 11, x - 3, y + 15.4, x + 5, y + 19 );
    heartShape.bezierCurveTo( x + 12, y + 15.4, x + 16, y + 11, x + 16, y + 7 );
    heartShape.bezierCurveTo( x + 16, y + 7, x + 16, y, x + 10, y );
    heartShape.bezierCurveTo( x + 7, y, x + 5, y + 5, x + 5, y + 5 );

    const geometry = new THREE.ShapeGeometry( heartShape );
    const material = new THREE.MeshLambertMaterial( { color: 0xffffff } );
    const heart = new THREE.Mesh( geometry, material ) ;
    return heart;
}